import gql from 'graphql-tag';
import { scheduledSessionFieldsFragment } from '../fragments';

export const resumeScheduledSessionMutation = gql`
  mutation ResumeScheduledSession($id: ID!) {
    resumeScheduledSession(id: $id) {
      ...AdminScheduledSessionFields
    }
  }

  ${scheduledSessionFieldsFragment}
`;
